export const responsiveMixin = {
  data() {
    return {
      screenWidth: window.innerWidth,
      isInDingTalk: false
    }
  },
  computed: {
    isMobile() {
      return this.screenWidth <= 768;
    },
    isTablet() {
      return this.screenWidth > 768 && this.screenWidth <= 1024;
    },
    isDesktop() {
      return this.screenWidth > 1024;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.isInDingTalk = this.testIsInDingTalk();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    testIsInDingTalk() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('dingtalk') > -1 || ua.indexOf('dingtalk') > -1;
    }
  }
}